<template>
  <div class="user-badge" @click="openProfile" role="button" tabindex="0">
    <div class="avatar">{{ initials }}</div>
    <div class="info">
      <div class="name">{{ displayName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserBadge',
  props: {
    name: { type: String, default: '' }
  },
  computed: {
    displayName() {
      if (this.name) return this.name
      try {
        const stored = localStorage.getItem('username') || localStorage.getItem('user')
        if (stored) return stored
      } catch (e) {
        console.log(e)
      }
      return 'مستخدم'
    },
    initials() {
      const parts = (this.displayName || '').trim().split(/\s+/)
      if (!parts.length) return 'م'
      if (parts.length === 1) return parts[0].slice(0, 1).toUpperCase()
      return (parts[0][0] + parts[parts.length-1][0]).toUpperCase()
    }
  },
  methods: {
    openProfile() {
      this.$emit('open')
    }
  }
}
</script>

<style scoped>
.user-badge { display:flex; align-items:center; gap:10px; cursor:pointer; padding:6px 8px; border-radius:10px; transition: background 140ms ease; }
.user-badge:hover { background: rgba(255,255,255,0.04) }
.avatar { width:36px; height:36px; border-radius:50%; background:var(--primary-color-1); color:#667eea; display:flex; align-items:center; justify-content:center; font-weight:700 }
.info .name { font-size:14px; color: #667eea; font-weight:700 }
</style>
